/* Import Css Style */
import './styles/Focus3.css'
/* External Component */
import {BUTTON_BLHS} from "../subComponents/BUTTON_BLHS";
import {Focus3_sub} from "../subComponents/Focus3_sub";
/* External assets */
import {faArrowRightLong} from "@fortawesome/free-solid-svg-icons"
import startup_diversity from "./../assets/Focus3/startup_diversity.jpeg"
import startup_diversity_2 from "./../assets/Focus3/shutterstock_2205301441.jpg"
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export const Focus3 = () =>{

    let scrollNextF3 = () => {
        document.querySelector('.Focus4_Container').scrollIntoView({behavior: "smooth"
            , block: 'center'
        })
    }

    return(
        <div class="Focus3_Container">
            <div class="Focus3_row_1">
                <div class="Focus3_row_1_column_1">
                    <img src={startup_diversity} alt={"diversity"} class={"diversity_focus3"} />
                </div>
                <img src={startup_diversity_2} alt={"diversity"} className={"women_1_cropped_focus3"}/>
                <div className="Focus3_row_1_column_2">
                    <p class="Focus3_row_1_column_2_text_1 yui3-cssreset">
                        <div>Quand l’innovation <br/> entrepreneuriale rencontre </div> l’inclusion et la <div class={"UnderLineHeader"} style={{color: 'var(--clr-white1)', fontSize:'2.35rem'}}>diversité</div> ! </p>
                    {/*<hr class="Focus3_hr"/>*/}
                    <p className="Focus3_row_1_column_2_text_2">
                        Avec SOS Jeunes Pousses, Rachid et Myriam Djebbouri accompagnent celles et ceux qui ont une idée, un rêve ou un projet, mais pas toujours les bons réseaux ni les bons codes.
                        <br/>
                        <br/>
Nous sensibilisons, détectons, préparons et propulsons les talents cachés des quartiers prioritaires, des zones rurales, des étudiants boursiers, des personnes en situation de handicap ou en recherche d’opportunités.
<br/>
<br/>
👉 Notre mission : donner à chacun les moyens de transformer son potentiel en réussite entrepreneuriale.</p>

                    <p style={{cursor: 'pointer'}} className="TestElig">
                        <BUTTON_BLHS
                        content="Test d'éligibilité"
                        textColor="var(--clr-purple-text)"
                        wrapColor="var(--clr-headerColor)"
                        borderColor="var(--clr-purple-text)"
                        wrapHoverColor="black"
                        urlTo={"https://sig.ville.gouv.fr/"}
                    />

                    </p>
                </div>
            </div>

            <div className="Focus3_row_2">
                <p class="objectives_Focus3_row_2">Nos objectifs</p>
                <div class="Focus3_row_2_subs_wrapper">
                    <Focus3_sub
                        number='1'
                        title='Donner envie d’oser'
                        text='Dans les quartiers, beaucoup ont des idées mais ne savent pas par où commencer. Nous voulons informer et sensibiliser les jeunes et les habitants pour leur montrer que l’entrepreneuriat et le numérique sont à leur portée.'
                    />
                    <Focus3_sub
                        number='2'
                        title='Détecter les talents cachés'
                        text='Certains portent déjà un projet, d’autres ont juste une curiosité pour le digital. Notre rôle, c’est de les encourager, de leur donner confiance et de les aider à transformer une envie en vraie opportunité.'
                    />
                    <Focus3_sub
                        number='3'
                        title='Former pour construire l’avenir'
                        text='À travers des ateliers concrets et des accompagnements, nous préparons les jeunes et les habitants à créer leur activité, à apprendre les métiers du numérique et à se projeter dans les technologies d’avenir'
                        text_2='👉 En résumé : on éclaire les chemins, on révèle les talents, et on donne les clés pour entreprendre sa vie.'
                    />
                </div>
                <p style={{marginLeft:'auto', marginRight:'auto'}}>
                <BUTTON_BLHS
                    content = "Faire un don 💛"
                    textColor="var(--clr-purple-text)"
                    wrapColor="var(--clr-headerColor)"
                    borderColor="var(--clr-purple-text)"
                    wrapHoverColor="black"
                    class="BUTTON_FOCUS4_COMP2"
                    urlTo="https://www.helloasso.com/associations/sos-jeunes-pousses"
                />
                </p>

            </div>

            <div style={{cursor: 'pointer'}} onClick={scrollNextF3  } className="ScrollDownBiggestContainer">
                <div className="ScrollDown">
                    S C R O L L
                </div>
                <div className="ArrowDownLongScroll">
                    <FontAwesomeIcon icon={faArrowRightLong}/>
                </div>
            </div>



        </div>
    )
}
